import { set, unset } from 'lodash';
import * as types from '../constants';
import { cloneState } from '../utils/stateUtils';

const INITIALSTATE = {
  summary: [],
  displayValidationError: false
};

export default function validationReducer(state = INITIALSTATE, action) {
  let st = Object.assign({}, state);

  switch (action.type) {
    case types.SET_VALIDATION_ERROR:
      st = cloneState(state);
      const { path, error } = action.payload;

      if (action.payload.error) {
        set(st, path, error);
        st.summary = [...st.summary.filter((err) => err.path !== path), { path, error }];
      }
      else {
        unset(st, action.payload.path, action.payload.error);
        st.summary = [...st.summary.filter((err) => err.path !== path)];
      }
      return st;
    case types.DISPLAY_UI_VALIDATIONS:
      st.displayValidationError = true;
      return st;
    default:
      return st;
  }
}
